module.exports = __webpack_public_path__ + "d4e721748e60e45c8d8e5d72e9d015d1.png";